module.exports = __webpack_public_path__ + "img/daren_en3.72a88b3b.jpg";